import { render, staticRenderFns } from "./GeofenceReport.vue?vue&type=template&id=99c9b630&scoped=true&"
import script from "./GeofenceReport.vue?vue&type=script&lang=js&"
export * from "./GeofenceReport.vue?vue&type=script&lang=js&"
import style0 from "./GeofenceReport.vue?vue&type=style&index=0&id=99c9b630&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99c9b630",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99c9b630')) {
      api.createRecord('99c9b630', component.options)
    } else {
      api.reload('99c9b630', component.options)
    }
    module.hot.accept("./GeofenceReport.vue?vue&type=template&id=99c9b630&scoped=true&", function () {
      api.rerender('99c9b630', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Reports/GeofenceReport.vue"
export default component.exports